<template>
    <div class="admin">
        <h1>The Admin Page!</h1>
        <div class="heading">
            <div class="circle">1</div>
            <h2>Add an Item</h2>
        </div>
        <div class="add">
            <div class="form">
                <input v-model="title" placeholder="Title">
                <div>
                    <br>
                    <textarea v-model="description" placeholder="description"/> <!--description of new item-->
                </div>
                <p></p>
                <!---type="file" displays a "browse" button so we can select from collection of photos, @change lets us know
                when a photo was clicked and selected--->
                <input type="file" name="photo" @change="fileChanged">
                <!--if we click Upload button, then then we call upload function to upload a photo to the server-->
                <button @click="upload">Upload</button>
            </div>
            <div class="upload" v-if="addItem"> <!--do this if item was added-->
                <h2>{{addItem.title}}</h2>
                <img :src="addItem.path" />
            </div>
        </div>
        <div class="heading">
            <div class="circle">2</div>
            <h2>Edit/Delete an Item</h2>
        </div>
        <div class="edit">
            <div class="form">
                <input v-model="findTitle" placeholder="Search">
                <div class="suggestions" v-if="suggestions.length > 0">
                    <!-- if user clicks on one of the items in the drop down box, then do selectItem(s)-->
                    <div class="suggestion" v-for="s in suggestions" :key="s.id" @click="selectItem(s)">{{s.title}}
                    </div>
                </div>
                <div>
                    <br>
                    <textarea v-model="newDescription" placeholder="NewDescription"/> <!--description of edited item-->
                </div>
            </div>
            <div class="upload" v-if="findItem">
                <input v-model="findItem.title">
                <p></p>
                <img :src="findItem.path" />
            </div>
            <div class="actions" v-if="findItem">
                <button @click="deleteItem(findItem)">Delete</button>
                <button @click="editItem(findItem)">Edit</button> <!-- calls editItem() when clicked -->
            </div>
        </div>
    </div>
</template>

<script>
    //import axios library from axios (axios lets use connect front end to back end) (axios was installed & is in node_modules)
    import axios from 'axios';
    export default { //anyone who uses this view (the router) can have a name to use it w/
        name: 'Admin',
        data() {
            return {
                title: "", //user enters this
                file: null, //user enters this
                addItem: null, //when we add an item we sent it to back end, back-end sends use json object which we store as addItem
                items: [],
                findTitle: "", //title the user types in to edit/delete
                findItem: null,
                description: "",
                newDescription: "",
                descriptionUpdated: null, //if description was edited
            }
        },
        created() {
            this.getItems(); //calls this when admin.vue is first loaded, getItems so we an edit them
        },
        computed: { //computed will be run/triggered when this.items or findTitle changes
            suggestions() {
                //looks at this.items that we fetched form the DB, uses filter() to find the item with the title the user wants
                let items = this.items.filter(item => item.title.toLowerCase().startsWith(this.findTitle.toLowerCase()));
                return items.sort((a, b) => a.title > b.title);
            }
        },
        methods: {
            fileChanged(event) { //comes from change event handler (above)
                //we use the event passed to us to find the name of the file that the user selected, and we store this in file.
                this.file = event.target.files[0]
            },
            selectItem(item) {
                this.findTitle = ""; //clears input field
                this.findItem = item; //sets findItem to the item the user selected
            },
            async upload() { //comes from click event handler (above)
               //we are send a file from front end (what the user fills out) to back end
                try {
                    const formData = new FormData(); //(create a formData object to send to backend)
                    //create json object that represents the form the user filled out
                    //this.file is the file (this is how you append file to formData object)
                    formData.append('photo', this.file, this.file.name)
                    //await means await for this to finish, so upload is async
                    let r1 = await axios.post('/api/photos', formData); //post formData to create a new file to /api/photos
                    let r2 = await axios.post('/api/items', { //to represent this in DB, use title and path to find it
                        title: this.title,
                        path: r1.data.path,
                        description: this.description, //todo: is this right?
                    });
                    this.addItem = r2.data; //take r2.data and store in this.addItem (use this in HTML above)
                } catch (error) {
                    console.log(error);
                }
            },
            async getItems() {
                try {
                    let response = await axios.get("/api/items"); //
                    this.items = response.data;
                    return true;
                } catch (error) {
                    console.log(error);
                }
            },
            async deleteItem(item) {
                try {
                    await axios.delete("/api/items/" + item._id);
                    this.findItem = null; //removes item from vue
                    this.getItems(); //get new list of items
                    return true;
                } catch (error) {
                    console.log(error);
                }
            },
            //this sends a PUT request to the REST API endpoint at /api/items/:id
            async editItem(item) {
                try {
                    await axios.put("/api/items/" + item._id, { //use item._id to get the right id
                        title: this.findItem.title, //user specifies title
                        newDescription: this.newDescription, //todo: is this right?
                    });
                    this.findItem = null; //clear out findItem from vue
                    // this.descriptionUpdated = this.newDescription; //description was updated
                    this.newDescription = ""; //clears input field
                    this.getItems(); //get new list of items
                    return true;
                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>



<style scoped>
  .image h2 {
    font-style: italic;
    font-size: 1em;
  }

  .heading {
    display: flex;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .heading h2 {
    margin-top: 8px;
    margin-left: 10px;
  }

  .add,
  .edit {
    display: flex;
  }

  .circle {
    border-radius: 50%;
    width: 18px;
    height: 18px;
    padding: 8px;
    background: #333;
    color: #fff;
    text-align: center
  }

  /* Form */
  input,
  textarea,
  select,
  button {
    font-family: 'Montserrat', sans-serif;
    font-size: 1em;
  }

  .form {
    margin-right: 50px;
  }

  /* Uploaded images */
  .upload h2 {
    margin: 0px;
  }

  .upload img {
    max-width: 300px;
  }

  /* Suggestions */
  .suggestions {
      width: 200px;
      border: 1px solid #ccc;
  }

  .suggestion {
      min-height: 20px;
  }

  .suggestion:hover {
      background-color: #5BDEFF;
      color: #fff;
  }
</style>